import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'min-h-[100px] w-full rounded-lg border border-neutral-300 bg-white px-3 py-2 text-base text-yhelp-black',
        'placeholder:text-neutral-400 focus-visible:border-yhelp-yellow focus-visible:outline-none',
        'dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-100 dark:placeholder:text-neutral-500',
        invalid && 'border-priority-critico',
        className,
      )}
      {...rest}
    />
  );
});
